import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_delivery_note = async (delivery_note) => {
  try {
    const data = {
      sales_order: delivery_note?.sales_order,
      customer: delivery_note?.customer,
      number: delivery_note?.number,
      date: delivery_note?.date,
      due_date: delivery_note?.due_date,
      reference: delivery_note?.reference,
      salesman: delivery_note?.salesman,
      status: delivery_note?.status,
      details: delivery_note?.details,
      total: delivery_note?.total,
      note: delivery_note?.note,
      id: delivery_note?.id ? delivery_note?.id : null,
      source: delivery_note?.source ? delivery_note?.source : null,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/create-delivery-note`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const update_delivery_note = async (delivery_note) => {
  try {
    const data = {
      id: delivery_note?.id,
      sales_order: delivery_note?.sales_order,
      customer: delivery_note?.customer,
      number: delivery_note?.number,
      date: delivery_note?.date,
      due_date: delivery_note?.due_date,
      reference: delivery_note?.reference,
      salesman: delivery_note?.salesman,
      status: delivery_note?.status,
      details: delivery_note?.details,
      total: delivery_note?.total,
      note: delivery_note?.note,
      source: delivery_note?.source ? delivery_note?.source : null,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/update-delivery-note`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const delete_delivery_note = async (delivery_note) => {
  try {
    const data = {
      id: delivery_note?.id,
      source: delivery_note?.source ? delivery_note?.source : null,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/delete-delivery-note`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_delivery_note = async (delivery_note) => {
  try {
    const data = {};
    if (delivery_note?.id) data.id = delivery_note.id;
    else if (delivery_note?.number) data.number = delivery_note.number;
    else return { status: false, message: "Delivery Note ID or number is required" };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-delivery-note`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_delivery_note = async (delivery_note) => {
  try {
    const data = {
      search: delivery_note?.search,
      sort: delivery_note?.sort,
      customer: delivery_note?.customer,
      sales_order: delivery_note?.sales_order,
      date: delivery_note?.date,
      due_date: delivery_note?.due_date,
      status: delivery_note?.status,
      page: delivery_note?.page,
      source: delivery_note?.source,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-delivery-note`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_pending_sales_orders = async (params) => {
  try {
    const data = {
      search: params?.search,
      customer: params?.customer
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-pending-sales-orders`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_sales_order_pending_details = async (params) => {
  try {
    const data = {
      id: params?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-sales-order-pending-details`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  create_delivery_note,
  update_delivery_note,
  delete_delivery_note,
  get_delivery_note,
  get_all_delivery_note,
  get_pending_sales_orders,
  get_sales_order_pending_details,
};